import { render } from "./BrandTyreRange.vue?vue&type=template&id=d26602d2&scoped=true"
import script from "./BrandTyreRange.vue?vue&type=script&lang=js"
export * from "./BrandTyreRange.vue?vue&type=script&lang=js"

import "./BrandTyreRange.vue?vue&type=style&index=0&id=d26602d2&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d26602d2"]])

export default __exports__